export const GET_OFFER_REQUEST = "GET_OFFER_REQUEST"
export const GET_OFFER_SUCCESS = "GET_OFFER_SUCCESS"
export const GET_OFFER_ERROR = "GET_OFFER_ERROR"